import useSWR from 'swr'
import { getApiVersion, http } from '../utils/domain'
import { stringifyQuery } from '../utils/query'

const prefix = (appId) => {
  return `${getApiVersion()}/apps/${appId}/role`
}

// 获取所有角色
export const getRolesData = (appId) => {
  return http()
    .get(`${prefix(appId)}/allRoles`)
    .json()
}

//  获取某个角色
export const getRolesMoreData = (appId, id) => {
  return http()
    .get(`${prefix(appId)}/${id}`)
    .json()
}

// 根据组织获取角色列表
export const rolesByOrg = (appId, params) => {
  return http()
    .get(`${prefix(appId)}/by_org${stringifyQuery(params)}`)
    .json()
}

const getAllRoles = (appId) => {
  return http()
    .get(`${prefix(appId)}/allRoles`)
    .json()
}
// 获取所有角色
export const allRolesSWR = (appId) => {
  const { data, error, mutate } = useSWR('role', () => getAllRoles(appId))
  return {
    allRoles: data && data.data ? data.data : [],
    allRolesMutate: mutate,
    isLoading: !error && !data,
  }
}

// 添加角色
export const addRole = (appId, data) => {
  return http()
    .post(`${prefix(appId)}`, data)
    .json()
}

// 修改角色
export const updateRole = (appId, data) => {
  return http()
    .put(`${prefix(appId)}`, data)
    .json()
}

// 删除角色
export const deleteRole = (appId, id) => {
  console.log('deleterole')
  return http().delete(`${prefix(appId)}/${id}`)
}
